<template>
    <a-card title="菜单信息" class="mb-15">
        <a-descriptions :column="1">
            <a-descriptions-item label="菜单编号">{{ record.menuCode }}</a-descriptions-item>
            <a-descriptions-item label="菜单名称">{{ record.menuName }}</a-descriptions-item>
            <a-descriptions-item label="菜单路由标识">{{ record.identifier }}</a-descriptions-item>
            <a-descriptions-item label="菜单请求路径">{{ record.url }}</a-descriptions-item>
            <a-descriptions-item label="模块名称">{{ record.urlPrefix || '--' }}</a-descriptions-item>
        </a-descriptions>
    </a-card>
</template>

<script>
import {onBeforeUnmount, onMounted, ref} from "vue";
import bus from "@/utils/bus";
import {getAction} from "@/utils/http/service";
import {sys_menu} from "@/api/adminService";

export default {
    name: "MenuInfo",
    setup() {
        const record = ref({})

        const getMenuInfo = (id) => {
            if (id) {
                getAction({
                    url: sys_menu.getDetail,
                    params: {
                        id: id
                    }
                }).then(res => {
                    record.value = res
                })
            } else {
                record.value = {};
            }

        }

        onMounted(() => {
            bus.$on('onMenuSelect', getMenuInfo)
        })
        onBeforeUnmount(() => {
            bus.$off('onMenuSelect', getMenuInfo)
        })
        return {
            record,
        }

    }
}
</script>

<style scoped lang="less">
.ant-card{
    background-color: #ffffff;
}
</style>
